var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRedInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_37484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.3125C6.31066 4.3125 6.5625 4.56434 6.5625 4.875V6.375C6.5625 6.68566 6.31066 6.9375 6 6.9375C5.68934 6.9375 5.4375 6.68566 5.4375 6.375V4.875C5.4375 4.56434 5.68934 4.3125 6 4.3125Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34392 1.11384C5.54324 0.998253 5.76957 0.937378 5.99998 0.937378C6.2304 0.937378 6.45672 0.998253 6.65605 1.11384C6.85492 1.22917 7.01988 1.39488 7.13429 1.59426C7.13455 1.59471 7.13481 1.59516 7.13507 1.59561L11.259 8.71874C11.374 8.91793 11.4346 9.14384 11.4348 9.37384C11.435 9.60384 11.3748 9.82986 11.2602 10.0292C11.1455 10.2286 10.9805 10.3944 10.7816 10.5099C10.5827 10.6254 10.357 10.6867 10.127 10.6875L10.125 10.6875H1.87498L1.873 10.6875C1.643 10.6867 1.41725 10.6254 1.21837 10.5099C1.01949 10.3944 0.854459 10.2286 0.73981 10.0292C0.625161 9.82985 0.564921 9.60384 0.565125 9.37384C0.565329 9.14384 0.625969 8.91793 0.740971 8.71874L4.8649 1.59561C4.86517 1.59513 4.86544 1.59466 4.86571 1.59419C4.98013 1.39484 5.14507 1.22915 5.34392 1.11384ZM5.35311 1.875L5.83991 2.15683L1.71525 9.28125C1.71521 9.28131 1.71528 9.28119 1.71525 9.28125C1.69888 9.30966 1.69015 9.34205 1.69012 9.37484C1.6901 9.40769 1.6987 9.43998 1.71508 9.46846C1.73146 9.49695 1.75503 9.52063 1.78345 9.53713C1.81166 9.55352 1.84367 9.56226 1.87629 9.5625H10.1237C10.1563 9.56226 10.1883 9.55352 10.2165 9.53713C10.2449 9.52063 10.2685 9.49695 10.2849 9.46846C10.3013 9.43998 10.3099 9.40769 10.3098 9.37484C10.3098 9.34208 10.3012 9.3099 10.2849 9.28151C10.2848 9.28142 10.2849 9.28159 10.2849 9.28151L6.15864 2.15439C6.14265 2.12644 6.11955 2.1032 6.09169 2.08704C6.06383 2.07089 6.03219 2.06238 5.99998 2.06238C5.96778 2.06238 5.93614 2.07089 5.90828 2.08704C5.88041 2.1032 5.85731 2.12643 5.84132 2.15439L5.35311 1.875Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9C6.41421 9 6.75 8.66421 6.75 8.25C6.75 7.83579 6.41421 7.5 6 7.5C5.58579 7.5 5.25 7.83579 5.25 8.25C5.25 8.66421 5.58579 9 6 9Z",
    fill: "#F5222D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_37484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRedInvoice);
export default __webpack_public_path__ + "static/media/warning-red-invoice.4fb657c9.svg";
export { ForwardRef as ReactComponent };